import { Alert, Dialog, Stack, Typography } from '@all-manager/design-system-v2';
import type { TopicDatabase } from '../../../../types';
import { useTopicArchiveModal } from './useTopicArchiveModal';

// Keeps the French quotes and question mark on the topic name's line.
const NBSP = ' ';

type Props = {
  /** Archived topics are restored, active ones archived. */
  topic: TopicDatabase;
  onClose: () => void;
};

export default function TopicArchiveModal(props: Props) {
  const hook = useTopicArchiveModal(props);

  return (
    <Dialog
      open
      onClose={hook.handleClose}
      maxWidth="xs"
      fullWidth
      title={hook.isArchived ? 'Désarchiver le sujet' : 'Archiver le sujet'}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: hook.isArchived ? 'Désarchiver' : 'Archiver',
          onClick: hook.handleConfirm,
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: hook.handleClose,
          disabled: hook.isPending,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}
        <Typography variant="body1">
          {hook.isArchived ? 'Désarchiver' : 'Archiver'} le sujet «{NBSP}{props.topic.name}{NBSP}»{NBSP}?
        </Typography>
        <Typography variant="body2">
          {hook.isArchived
            ? 'Il réapparaîtra parmi les sujets actifs.'
            : 'Il quittera les sujets actifs et pourra être désarchivé à tout moment.'}
        </Typography>
      </Stack>
    </Dialog>
  );
}
